import { render, staticRenderFns } from "./CustomOverlay.vue?vue&type=template&id=ff43009e&scoped=true"
import script from "./CustomOverlay.vue?vue&type=script&lang=js"
export * from "./CustomOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff43009e",
  null
  
)

export default component.exports